/**
 * Stable CSS class names for E2E — pages/SiteManagement/MenuManagement.
 * Containers use `menu-management__<element>`; inputs and user-interactable
 * controls use `menu-management-input--<name>`.
 */
export const MM = {
    page: 'menu-management-page',
    root: 'menu-management',

    /* --- Edit dialog wrapper ----------------------------------------- */
    editDialog: 'menu-management__edit-dialog',

    /* --- Header / toolbar -------------------------------------------- */
    titleBox: 'menu-management__title-box',
    title: 'menu-management__title',
    addBtnBox: 'menu-management__add-btn-box',
    btnAdd: 'menu-management-input--button-add',

    /* --- Filters ------------------------------------------------------ */
    filtersRow: 'menu-management__filters-row',
    searchBox: 'menu-management__search-box',
    inputSearch: 'menu-management-input--search',
    appBox: 'menu-management__app-box',
    appControl: 'menu-management__app-control',
    inputAppSelect: 'menu-management-input--app-select',
    appOption: 'menu-management__app-option',

    /* --- Table -------------------------------------------------------- */
    tablePaper: 'menu-management__table-paper',
    tableContainer: 'menu-management__table-container',
    table: 'menu-management__table',
    tableHead: 'menu-management__table-head',
    tableHeadRow: 'menu-management__table-head-row',
    tableHeadCell: 'menu-management__table-head-cell',
    tableHeadCellExpand: 'menu-management__table-head-cell--expand',
    tableHeadCellMenu: 'menu-management__table-head-cell--menu',
    tableHeadCellOrder: 'menu-management__table-head-cell--order',
    tableHeadCellIcon: 'menu-management__table-head-cell--icon',
    tableHeadCellCountry: 'menu-management__table-head-cell--country',
    tableHeadCellRole: 'menu-management__table-head-cell--role',
    tableHeadCellDelete: 'menu-management__table-head-cell--delete',
    tableHeadCellEdit: 'menu-management__table-head-cell--edit',
    tableBody: 'menu-management__table-body',
    mainRowWrap: 'menu-management__main-row-wrap',
} as const;

export const mmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
